import { useState, useEffect } from 'react';
import { useAuth } from '../auth/useAuth';
import { API_BASE_URL } from '../services/api';

/**
 * Hook to fetch equipment from database
 *
 * @param {string} type - Equipment type (bess, solar, generator, etc.)
 * @returns {Object} { equipment, loading, error }
 */
function useEquipmentDatabase(type) {
    const [equipment, setEquipment] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { currentUser } = useAuth();

    useEffect(() => {
        const fetchEquipment = async () => {
            if (!currentUser) {
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);

            try {
                const token = await currentUser.getIdToken();
                const response = await fetch(`${API_BASE_URL}/api/site_dna/v1/equipment/${type}/active`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch ${type} equipment`);
                }

                const data = await response.json();
                console.log(`✅ [useEquipmentDatabase] Fetched ${type}:`, data.equipment?.length || 0, 'items');
                setEquipment(data.equipment || []);
            } catch (err) {
                console.error(`Error fetching ${type} equipment:`, err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchEquipment();
    }, [type, currentUser]);

    return { data: equipment, loading, error };
}

export default useEquipmentDatabase;
